import { useSelector } from "react-redux";
import { IAppState } from "../store/types";

export const useUserCountrySelector = () =>
  useSelector((state: IAppState) => state.user.country);
